import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IKeyData } from "infrastructure";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";

import { IEnterprise, getInitialEnterprisesState, IEnterprisesState } from "./Enterprise.state";

const initialState = getInitialEnterprisesState();

export const enterprises = createSlice({
  name: "enterprises",
  initialState: initialState,
  reducers: {
    loadEnterprises: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: true, notification: undefined }
      };
    },
    loadEnterprisesCompleted: (state, action: PayloadAction<IKeyData<IEnterprise[]>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: action.payload.data }
      };
    },
    loadEnterprisesFailed: (state, action: PayloadAction<IKeyData<INotification>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, notification: action.payload.data }
      };
    },
    reset: actionProcessing.createWithClearNotification((state: IEnterprisesState, action: PayloadAction<IKeyData>) => {
      const { [action.payload.id]: _, ...rest } = state;

      return {
        ...rest
      };
    })
  }
});
